import { Link, createFileRoute } from '@tanstack/react-router';
import { ChevronLeft } from 'lucide-react';
import { PageBody, backLinkVariants } from '@wundo/ui';
import { PageHeader } from '@/components/PageHeader.tsx';
import { OrganisationForm } from '@/components/organisations/OrganisationForm.tsx';
import { OrganisationLogoSection } from '@/components/organisations/OrganisationLogoSection.tsx';
import { ReadingColumn } from '@/components/ReadingColumn.tsx';
import { useRecordOrganisation } from '@/lib/recordOrganisation.ts';

export const Route = createFileRoute('/_app/organisations/$id/edit')({
  staticData: { orgScope: 'record', orgScopeList: '/organisations' },
  component: EditOrganisationPage,
});

export function EditOrganisationPage() {
  const { id } = Route.useParams();
  useRecordOrganisation(id);

  return (
    <>
      <Link
        to='/organisations/$id'
        params={{ id }}
        className={backLinkVariants({ className: 'mb-2.5' })}
      >
        <ChevronLeft aria-hidden='true' />
        Organisation
      </Link>
      <PageHeader
        title='Edit Organisation'
        subtitle='Update organisation details and settings'
      />

      {/* The back-link has taken the space PageBody normally leaves for it. */}
      <PageBody flush className='mt-7'>
        <ReadingColumn>
          <OrganisationLogoSection organisationId={id} />
          <OrganisationForm organisationId={id} />
        </ReadingColumn>
      </PageBody>
    </>
  );
}
